import isString from 'lodash/isString';
import isNumber from 'lodash/isNumber';

import {isObject} from '../is-object';
import {TransformedResponseError} from '../../models/wiki/error';

export const isResponseError = (val: unknown): val is TransformedResponseError => {
    if (!isObject(val)) return false;

    if (
        !isString(val.message) ||
        !isString(val.code) ||
        !isNumber(val.status) ||
        !isObject(val.details)
    ) {
        return false;
    }

    return true;
};

export const isResponseErrorWithCode = (
    val: unknown,
    code: string | string[],
): val is TransformedResponseError => {
    if (!isResponseError(val)) {
        return false;
    }

    if (Array.isArray(code)) {
        return code.includes(val.code);
    }

    return code === val.code;
};
